// src/config/api.js
// USED FOR CRUD OPERATION 
// USE FOR LEAD, PACKAGE, USERS, 
export const BASE_URL = "https://zoho.goelectronix.in/api/";
// export const BASE_URL = "https://uatwarranty.goelectronix.co.in/api/";

// export const SWAGGER_URL = "https://agitated-cori.103-195-185-254.plesk.page/api";

export const SWAGGER_URL = "https://testzypay.com/swagger/index.html";

export const GET_PINCODE = "https://goelectronix.in/public/api/v1/";

export const Goex_URL = "https://goelectronix.in/api/v1/";


// appid and secretkey for pan verification
export const APPID = "170VSRM5NLDT0LLU8TZRA1PRV2EIVB";

export const SecretKey = "TESTT56GXPUJ9JR5UKZO4WH6PQ2F8NTM5TQ6";

export const REACT_APP_GOOGLE_CLIENT_ID = "823380876934-0vv8oi4h4odg2626jmm26ivi8sv04teq.apps.googleusercontent.com";

export const GOOGLE_MAPS_API_KEY = "AIzaSyDLTSSa0MtTOZhx8BLE-OslReB05kVWxn0";

